import { useEffect, useState } from 'react';

const getActualVh = () => window.innerHeight * 0.01;

const useVh = () => {
   const [vh, setVh] = useState(0);

   const updateVh = () => {
      const newVh = getActualVh();
      document.documentElement.style.setProperty('--vh', `${newVh}px`);
      setVh(newVh);
   };

   useEffect(() => {
      updateVh();
      window.addEventListener('resize', updateVh);
      window.addEventListener('orientationchange', updateVh);
      return () => {
         window.removeEventListener('resize', updateVh);
         window.removeEventListener('orientationchange', updateVh);
      };
   }, []);

   return vh;
};

export default useVh;
